export default __webpack_public_path__ + "static/P2P_Cam_Live_04-bf7a4aefae1347fa45adac0ce5437cc8.webp";